export default class ReferenceAlignment {

    public word?: string = undefined;
    public text?: string = undefined;
    public start_time?: number = undefined;
    public end_time?: number = undefined;
    public start_index?: string = undefined;
    public end_index?: string = undefined;

    public assign(response: any): ReferenceAlignment {
        if (response) {
            for (const key in response) {
                if (response.hasOwnProperty(key) && this.hasOwnProperty(key)) {
                    (this as any)[key] = response[key];
                }
            }
        }
        if (!this.word) {
            this.word = this.text;
            this.text = undefined;
        }
        return this;
    }
}
